import { Controller } from "@hotwired/stimulus"

// A "Gå til toppen" button fixed in the bottom-right corner. The calendar and
// the front page are long, and the audience is 55+ — scrolling back by hand is
// the kind of small friction worth removing.
//
// The button is hidden until the page has been scrolled a screenful, so it
// never covers content on a short page. It stays in the tab order only while
// visible: a control you cannot see but can still tab to is worse than not
// having one.
export default class extends Controller {
  static values = { threshold: { type: Number, default: 600 } }

  connect() {
    this.onScroll = this.toggle.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.toggle()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  toggle() {
    const show = window.scrollY > this.thresholdValue
    this.element.classList.toggle("opacity-0", !show)
    this.element.classList.toggle("pointer-events-none", !show)
    this.element.hidden = !show
  }

  // Honours prefers-reduced-motion: the browser applies it to "smooth".
  scrollToTop(event) {
    event.preventDefault()
    window.scrollTo({ top: 0, behavior: "smooth" })

    // Move focus to the top of the page as well, or a keyboard user is left
    // where they were while the page scrolls away underneath them.
    //
    // preventScroll matters: <main> is taller than the window, so focusing it
    // makes the browser scroll it into view by its bottom edge — which fought
    // the smooth scroll and left the page parked partway down, never reaching
    // the top at all.
    document.getElementById("main")?.focus({ preventScroll: true })
  }
}
